var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLessons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "xMidYMid meet",
    "data-bbox": "48.7 61.6 102.6 90.9",
    viewBox: "48.7 61.6 102.6 90.9",
    height: 200,
    width: 200,
    xmlns: "http://www.w3.org/2000/svg",
    "data-type": "color",
    role: "presentation",
    "aria-hidden": "true",
    "aria-label": "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F58220",
    d: "M75.2 61.6V69l-14.3-7.4v5.9l38.2 13.1-23.9-19z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F58220",
    d: "M139.1 61.6L125 68.9v-7.3l-24.1 19 38.2-13.1v-5.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5E17EB",
    d: "M139.1 67.5l-38.2 13.1-.9.3-.9-.3-38.2-13.1-12.2-4.2v71.6l51.3 17.6 51.3-17.6V63.3l-12.2 4.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLessons);
export default __webpack_public_path__ + "static/media/lessons.abf67996d1aadc58b133728df20210fa.svg";
export { ForwardRef as ReactComponent };